import * as React from 'react';
import { cn } from '@verlo/shared/lib/utils';

// One section of Company settings (Back office sweep, Oct 2026). The same parts as the shared
// Card, so each settings card reads the same: a hairline box, a Manrope title and a line
// saying what it decides, its fields below. Its own Save sits at the foot, right.

export const Card = React.forwardRef(({ className, ...props }, ref) => (
  <section ref={ref} className={cn('rounded-lg border border-hairline bg-white', className)} {...props} />
));
Card.displayName = 'SettingsSection';

export const CardHeader = ({ className, ...props }) => (
  <div className={cn('space-y-1 border-b border-hairline px-5 py-4', className)} {...props} />
);

// A size someone passed for the old card (text-lg) gives way to the section's own.
export const CardTitle = ({ className, ...props }) => (
  <h2 className={cn('font-heading text-[16px] font-extrabold text-ink', className?.replace(/\btext-lg\b/, ''))} {...props} />
);

export const CardDescription = ({ className, ...props }) => (
  <p className={cn('max-w-2xl text-[13px] text-ink-soft', className)} {...props} />
);

export const CardContent = ({ className, ...props }) => (
  <div className={cn('px-5 py-4', className)} {...props} />
);
